export default function TestimonialSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="w-full lg:w-2/5">
            <div className="rounded-2xl overflow-hidden aspect-[4/5] w-full">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20artistic%20portrait%20of%20a%20person%20with%20a%20thoughtful%20expression%2C%20sitting%20in%20a%20sunlit%20minimal%20interior%2C%20wearing%20neutral%20tone%20casual%20outfit%2C%20soft%20window%20light%2C%20cream%20walls%2C%20modern%20Scandinavian%20aesthetic%2C%20editorial%20lifestyle%20photography%2C%20warm%20and%20authentic%20atmosphere&width=800&height=900&seq=testimonial-portrait-v3&orientation=portrait"
                alt="Hipobuy Spreadsheet user experience"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="w-full lg:w-3/5">
            <span className="text-xs text-foreground-400 mb-4 block">
              (Verified Buyer)
            </span>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4">
              Hipobuy Spreadsheet
              <br />
              <span className="text-foreground-400">Changed My Shopping Game</span>
            </h2>
            <blockquote className="text-foreground-600 text-base md:text-lg leading-relaxed mb-6 max-w-lg">
              "I used to spend hours searching across different sites trying to find the right products. Since discovering Hipobuy Spreadsheet, everything is organized in one place. The category system is intuitive, and I can compare products side by side within seconds. It has genuinely made product research enjoyable rather than frustrating."
            </blockquote>
            <div className="text-sm font-semibold text-foreground-900">
              &mdash; Alex, UK
            </div>

            <div className="flex items-center space-x-3 mt-8">
              <button className="w-10 h-10 rounded-full border border-foreground-200 flex items-center justify-center text-foreground-400 hover:border-foreground-400 transition-colors">
                <i className="ri-arrow-left-line"></i>
              </button>
              <button className="w-10 h-10 rounded-full bg-foreground-900 flex items-center justify-center text-background-50">
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}